import React from "react";

export const SelectColumnFilter = (
  { column: { filterValue, setFilter, preFilteredRows, id } },
  { booleanTrue = "Yes", booleanFalse = "No" }
) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      value={filterValue}
      onChange={(e) => setFilter(e.target.value || undefined)}
      className="form-control form-control-sm order-history-table-filters"
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {typeof option == "boolean"
            ? option
              ? booleanTrue
              : booleanFalse
            : option}
        </option>
      ))}
    </select>
  );
};

export const StatusColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const options = React.useMemo(() => {
    const options = new Set();

    // status to only to display in the filter if they are in the data
    const status = [
      {
        sortOrder: 1,
        name: "Open",
      },
      //Grouping with In Transit
      // {
      //   sortOrder: 2,
      //   name: "Picked Up",
      // },
      {
        sortOrder: 3,
        name: "In Transit",
      },
      {
        sortOrder: 4,
        name: "Out for Delivery",
      },
      {
        sortOrder: 5,
        name: "Partial Delivery",
      },
      {
        sortOrder: 6,
        name: "Delivered",
      },
      {
        sortOrder: 7,
        name: "Possible Exception",
      },
    ];
    // const hiddenStatus = ["-Delivered-", "Delivered*", "Delivered**"];
    //If the statuses in these keys are found, we will add the values as options instead
    //i.e. if the status is Picked Up, we will add In Transit as an option.
    const hiddenStatusMap = {
      "Picked Up": ["In Transit"],
      "-Delivered-": ["Delivered"],
      // "Delivered*": //backend will now send either Delivered with Possible Exception(if order has a barcode that has delivery stop with no scan but does have scans for other things) or Possible Exception(if their is a barcode with a delivery stop that was never scanned at all) instead of Delivered*
      // "Delivered**": "Delivered with Possible Exception",
      "Delivered**": ["Delivered", "Possible Exception"],
      Exception: ["Delivered", "Possible Exception"],
      "Delivered with Possible Exception": ["Delivered", "Possible Exception"],
    };

    preFilteredRows.forEach((row) => {
      if (status.map((statu) => statu.name).includes(row.values[id])) {
        options.add(row.values[id]);
      }
      // else if (hiddenStatus.includes(row.values[id])) {
      // options.add("Delivered");
      // }
      else if (Object.keys(hiddenStatusMap).includes(row.values[id])) {
        // console.log(row.values[id]);
        // console.log(hiddenStatusMap[row.values[id]]);
        hiddenStatusMap[row.values[id]].forEach((mappedStatus) =>
          options.add(mappedStatus)
        );
        // options.add(hiddenStatusMap[row.values[id]]);
      }
    });

    // sort the options based on the sortOrder
    const sortedOptions = [...options.values()].sort((current, next) => {
      // console.log("Current: ", current);
      const currentSortOrder = status.find(
        (statu) => statu.name === current
      ).sortOrder;

      const nextSortOrder = status.find(
        (statu) => statu.name === next
      ).sortOrder;

      return currentSortOrder - nextSortOrder;
    });

    return sortedOptions;
  }, [id, preFilteredRows]);

  const handleOnFilterChange = (event) => {
    setFilter(event.target.value || undefined);
  };

  return (
    <select
      value={filterValue}
      onChange={handleOnFilterChange}
      className="form-control form-control-sm"
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export const CodStatusColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [hasNo, hasYes, statuses] = React.useMemo(() => {
    const optionsInData = new Set();
    const options = new Set();

    //Go through the data and add all COD options found
    preFilteredRows.forEach((row) => {
      optionsInData.add(row.values[id]);
    });

    //We want these specific COD options ordered like this so we check for them and add them manually in this order if they exist in the data
    if (optionsInData.has("No")) {
      options.add("No");
    }
    if (
      // (optionsInData.has("No") && optionsInData.size > 1) ||
      // (!optionsInData.has("No") && optionsInData.size > 0)
      [...optionsInData].filter((option) => option !== "No").length > 0 //if there are options other than "No" we want to also include a "Yes" option
    ) {
      //we use this option to filter for all rows that have a value other than "No". It's supposed to get the orders that are cod regardless of the status.
      options.add("Yes");
    }
    if (optionsInData.has("Unpaid")) {
      options.add("Unpaid");
    }
    if (optionsInData.has("Partial")) {
      options.add("Partial");
    }
    if (optionsInData.has("Paid")) {
      options.add("Paid");
    }

    //convert our manually ordered set and the set with all the data into arrays and combine them, then turn the combined data into a set again to get rid of duplicates
    //this will have all the options we have accounted for ordered correctly, and the ones that may be added in the future (that we haven't accounted for) show up after everything else.
    const combinedOptionsSet = new Set([...options, ...optionsInData]);
    const combinedOptions = [...combinedOptionsSet.values()];

    const hasNo = combinedOptions.includes("No");
    const hasYes = combinedOptions.includes("Yes");
    const statuses = combinedOptions.filter((option) => {
      return option !== "No" && option !== "Yes";
    });

    return [hasNo, hasYes, statuses]; //.values() does not seem to be necessary
  }, [id, preFilteredRows]);

  return (
    <select
      value={filterValue}
      onChange={(e) => setFilter(e.target.value || undefined)}
      className="form-control form-control-sm order-history-table-filters"
    >
      <option value="">All</option>
      {hasNo && <option value="No">No</option>}
      {hasYes && <option value="Yes">Yes</option>}
      {
        statuses.length > 0 &&
          // <optgroup label="By Status"> // {/*previously had these in opt group*/}
          statuses.map((status, i) => (
            <option key={i} value={status}>
              {status}
            </option>
          ))
        // </optgroup>
      }
    </select>
  );
};

export const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  const count = preFilteredRows.length;

  return (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder={`Search ${count} records...`}
      // placeholder="Search..."
      className="form-control form-control-sm order-history-table-filters"
    />
  );
};

export const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return <input type="checkbox" ref={resolvedRef} {...rest} />;
  }
);

//change this to modify the way the search grid searches
export const getCommonFilterTypes = () => ({
  text: (rows, id, filterValue) =>
    rows.filter((row) => {
      const rowValue = row.values[id];

      return rowValue !== undefined
        ? String(rowValue)
            .toLowerCase()
            .startsWith(String(filterValue.trim()).toLowerCase())
        : true;
    }),
  includesTrimmed: (rows, id, filterValue) =>
    rows.filter((row) => {
      const rowValue = row.values[id];

      return rowValue !== undefined
        ? String(rowValue)
            .toLowerCase()
            .includes(String(filterValue.trim()).toLowerCase())
        : true;
    }),
  //not using right now because it won't rerun when filterByInsured is changed, not sure why
  // orderHistoryInvoiceSearch: (rows, id, filterValue, filterByInsured)=>
  //   rows.filter((row) => {
  //     const rowValue = row.values[id];

  //     return rowValue !== undefined
  //       ? (String(rowValue)
  //           .toLowerCase()
  //           .includes(String(filterValue.trim()).toLowerCase())
  //         && filterByInsured ?
  //         (order.insured ||
  //         order.subInvoicesInsured.some((invoiceInsured) => {
  //           return invoiceInsured;
  //         }))
  //         : true
  //         )
  //       : true;
  //   }),
  equals: (rows, id, filterValue) =>
    rows.filter((row) => {
      const rowValue = row.values[id];

      return rowValue !== undefined ? String(rowValue) === filterValue : true;
    }),
});

//Custom Sort Types==============================
export const alphaNumericCaseInsensitive = (rowA, rowB, columnId) => {
  // console.log("a", rowA);
  // console.log("b", rowB);
  // console.log("columnID", columnId);
  // console.log(rowA.values[columnId].toLowerCase());
  // console.log(rowB.values[columnId].toLowerCase());
  // console.log(
  //   rowA.values[columnId].toLowerCase() > rowB.values[columnId].toLowerCase()
  // );
  // if (
  //   rowA.values[columnId].toLowerCase() > rowB.values[columnId].toLowerCase()
  // ) {
  //   return 1;
  // } else if (
  //   rowA.values[columnId].toLowerCase() < rowB.values[columnId].toLowerCase()
  // ) {
  //   return -1;
  // } else {
  //   return 0;
  // }
  return rowA.values[columnId].localeCompare(rowB.values[columnId]);
};

//End Custom Sort Types==========================
